"use client";

import { cn } from "@garther/ui/libs";
import { LucideIcon, Plus } from "lucide-react";

interface CreateCardProps {
  onClick: () => void;
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  className?: string;
  disabled?: boolean;
}

export function CreateCard({
  onClick,
  title,
  subtitle,
  icon: Icon = Plus,
  className,
  disabled = false
}: CreateCardProps) {
  return (
    <button
      className={cn(
        "group flex flex-col items-center justify-center gap-3 rounded-md border-2 border-dashed border-border hover:border-border-dark hover:bg-background-highlight transition-all duration-200 px-5 py-8 min-h-[180px] cursor-pointer bg-background-secondary/50",
        disabled && "opacity-50 cursor-not-allowed hover:border-border hover:bg-background-secondary/50",
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-background-highlight group-hover:bg-background-secondary transition-colors duration-200">
        <Icon className="h-6 w-6 text-text-secondary group-hover:text-text-primary transition-colors duration-200" />
      </div>
      <div className="text-center">
        <p className="text-responsive-md font-medium text-text-primary group-hover:text-text-primary transition-colors duration-200 font-literata">
          {title}
        </p>
        {subtitle && <p className="text-responsive-base text-text-secondary mt-1">{subtitle}</p>}
      </div>
    </button>
  );
}
